/**
 * Walk replyToMessageId chain to the top-level parent (thread root).
 */
export function getTopLevelParentId(message, allMsgs) {
  if (!message) return null;
  let current = message;
  const list = Array.isArray(allMsgs) ? allMsgs : [];
  while (current?.replyToMessageId) {
    const parentId = String(current.replyToMessageId);
    const parent = list.find((m) => String(m.id || m._id) === parentId);
    if (!parent) {
      return current.replyToMessageId;
    }
    current = parent;
  }
  return current?.id ?? current?._id ?? null;
}

/**
 * Build URL search params to open a message (and thread panel when applicable).
 */
export function buildChatNavigationSearch(targetMessage, channelMessages) {
  if (!targetMessage?.id) return '';

  const params = new URLSearchParams();
  params.set('messageId', targetMessage.id);

  if (targetMessage.replyToMessageId) {
    const threadId = getTopLevelParentId(targetMessage, channelMessages);
    if (threadId) {
      params.set('threadId', threadId);
    }
  }

  return params.toString();
}
